import { Link } from 'react-router';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import { Icon } from '@/comp/icon/icon';
import { AppContext } from '@/context/AppContext';
import { useContext, useMemo } from 'react';
import { affiliate_checkIsAllowToBookService } from '@/_helper/checkAccess';
import { checkTripStarts } from '@/_helper/checkTripStarts';
import TravelTile from '@/comp/travelTile';

export const CancellationOptions = () => {
    const { bookingData, bookingState } = useContext(AppContext);
    let service = 'cancellationService';

    const isTripAlreadyStarted = useMemo(() => checkTripStarts(), []);

    const isFallback = useMemo(() => {
        const cancellation = bookingData?.data?.allowedInteractions.cancellation;
        const partialCancellation = Object.values(cancellation?.partialCancellation ?? {}).some(
            (isAllowed) => isAllowed
        );
        return (
            !isTripAlreadyStarted &&
            !cancellation?.completeCancellation &&
            !partialCancellation &&
            bookingState !== 'XX'
        );
    }, [bookingState, bookingData?.data?.allowedInteractions.cancellation, isTripAlreadyStarted]);

    if (!bookingData || (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service))) {
        return null;
    }

    const { data } = bookingData ?? {};
    const { cancellation } = data?.allowedInteractions ?? {};

    return (
        <div className="tab-content-container">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>Stornierungsoptionen</h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {!isTripAlreadyStarted || cancellation.completeCancellation ? (
                    bookingState === 'XX' || data.bookingCancelled ? (
                        <TravelTile
                            name="cancellation"
                            icon="freeCancellation"
                            headline="Reise stornieren"
                            description="Ihre Reise wurde storniert"
                            state="is-already-booked"
                        />
                    ) : (
                        cancellation.completeCancellation && (
                            <TravelTile
                                name="cancellation"
                                icon="freeCancellation"
                                headline="Reise stornieren"
                                description="Im nächsten Schritt können Sie Ihre komplette Reise einfach stornieren."
                                state="show"
                                link={'stornierung'}
                                linkType="internal"
                                target="_blank"
                            />
                        )
                    )
                ) : (
                    <InfoCard type="large">
                        <div>
                            Ihre Reise kann nicht mehr storniert werden.
                            <br />
                            <br />
                            Wir hoffen, Sie genießen Ihren Urlaub! Bei Problemen oder Fragen vor Ort, melden Sie sich
                            bitte umgehend beim AurumTours Serviceteam unter{' '}
                            <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                        </div>
                    </InfoCard>
                )}

                {cancellation.partialCancellation.excursion && (
                    <TravelTile
                        key="excursion"
                        name="cancellation-excursion"
                        icon="freeCancellation"
                        headline="Ausflug stornieren"
                        description="Im nächsten Schritt können Sie Ihren Ausflug stornieren."
                        state="show"
                        link={'leistung-stornieren/ausflug'}
                        linkType="internal"
                        target="_blank"
                    />
                )}

                {cancellation.partialCancellation.seatReservation && (
                    <TravelTile
                        key="seatReservation"
                        name="cancellation-seatReservation"
                        icon="freeCancellation"
                        headline="Sitzplatzreservierung (Flug) <wbr/> stornieren"
                        description="Im nächsten Schritt können Sie Ihre gebuchten Sitzplätze stornieren."
                        state="show"
                        link={'leistung-stornieren/sitzplatzreservierung'}
                        linkType="internal"
                        target="_blank"
                    />
                )}

                {/* fallback in case of no possible cancellation */}
                {isFallback && (
                    <InfoCard type="large">
                        Für Ihre Reise sind im Moment leider keine Stornierungsoptionen verfügbar.
                    </InfoCard>
                )}
            </div>
        </div>
    );
};
